// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3Igy-","inputWrap":"styles_inputWrap__1ITrR","input":"styles_input__3Nm0k"};